// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoodOutlinedSvg from "@fishx/icons-svg/es/asn/GoodOutlined";
import FishxIcon from '../components/FishxIcon';

var GoodOutlined = function GoodOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoodOutlinedSvg
  }));
};

GoodOutlined.displayName = 'GoodOutlined';
export default React.forwardRef(GoodOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GoodOutlined.js
// module id = 2885
// module chunks = 0